import { axios, base } from '../http';

export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params });
};

export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params });
};

export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params);
};

export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params);
};

export const resetUserPassword = (params) => {
  return axios.post(`${base}/api/user/ResetPassword`, params);
};

export const decodeUserPassword = (params) => {
  return axios.post(`${base}/api/user/DecodePassword`, params);
};

export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }); //没做
};

/** 获取当前后台账号手机号绑定状态。 */
export const getMobileBinding = () => {
  return axios.get(`${base}/api/UserMobileBinding/Get`).then((res) => res.data);
};

/** 发送个人中心手机号绑定验证码。 */
export const sendMobileBindingCode = (params) => {
  return axios.post(`${base}/api/UserMobileBinding/SendCode`, params).then((res) => res.data);
};

/** 绑定当前后台账号手机号。 */
export const bindMobilePhone = (params) => {
  return axios.post(`${base}/api/UserMobileBinding/Bind`, params).then((res) => res.data);
};

/** 换绑当前后台账号手机号。 */
export const changeMobilePhone = (params) => {
  return axios.post(`${base}/api/UserMobileBinding/Change`, params).then((res) => res.data);
};

/** 解绑当前后台账号手机号。 */
export const unbindMobilePhone = (params) => {
  return axios.post(`${base}/api/UserMobileBinding/Unbind`, params).then((res) => res.data);
};

// 角色管理

export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params });
};

export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params });
};

export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params);
};

export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理

export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params });
};

export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params });
};

export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params);
};

export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params);
};

// 菜单模块管理

export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params });
};

export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params });
};

export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params });
};

export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params);
};

export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params);
};

export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  });
};

export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  });
};

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params);
};

export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, { params: params })
    .then((res) => res.data);
};

// Bug模块管理

export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params });
};

//微信公众�?

export const getNotMeasuredUserPage = (params) => {
  return axios.get(`${base}/api/TemperatureRecord/GetNotMeasuredUser`, {
    params: params,
  });
};

//获取大屏菜单配置

export const getCommRuleUserListPage = (params) => axios.get(`${base}/api/CommRuleBinding/GetListPage`, { params });

export const batchBindCommRuleUsers = (params) => axios.post(`${base}/api/CommRuleBinding/BatchBind`, params);

export const batchUnbindCommRuleUsers = (params) => axios.post(`${base}/api/CommRuleBinding/BatchUnbind`, params);

export const getScreenAdminPermission = (params) => axios.get(`${base}/api/ScreenPermissionAdmin/GetAdminPermission`, { params });

export const saveScreenAdminPermission = (params) => axios.post(`${base}/api/ScreenPermissionAdmin/SaveAdminPermission`, params);

// ---- 钉钉 PC 学校菜单配置 ----
